import { useContext } from 'react'
import RootStoreContext, { appContext } from 'stores/utils/RootStoreContext'

export type { appContext }

export function useRootStore() {
  return useContext<appContext>(RootStoreContext)
}
